import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Page } from "@/components/Layout";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";
import { useCart } from "@/lib/useCart";
import { useCurrency } from "@/lib/currency";
import { toast } from "sonner";
import { ShoppingBag, ShoppingCart, ArrowRight } from "@phosphor-icons/react";

export default function Shop() {
  const [items, setItems] = useState([]);
  const { count, add: addCart } = useCart();
  const { format } = useCurrency();

  useEffect(() => { api.get("/products").then((r) => setItems((r.data || []).filter((p) => p.product_type !== "package"))); }, []);

  const quickAdd = (e, p) => {
    e.preventDefault();
    e.stopPropagation();
    addCart(p);
    toast.success(`${p.name} added to cart`);
  };

  return (
    <Page>
      <Seo title="Shop · MindDhara" description="Books and tools for the mind." />
      <section className="md-section md-page-hero" data-testid="shop-hero">
        <div className="md-container">
          <div className="md-label-eyebrow mb-3">Shop</div>
          <h1 className="text-5xl md:text-6xl font-serif">Books and tools for the mind</h1>
          <div className="mt-6 flex justify-center">
            <Link to="/cart" className="btn-outline md-career-outline-light text-sm relative" data-testid="open-cart-btn">
              <ShoppingBag size={16} /> View Cart ({count})
            </Link>
          </div>
        </div>
      </section>
      <section className="md-section pt-0">
        <div className="md-container">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {items.map((p) => (
              <Link
                key={p.id}
                to={`/shop/${p.id}?trail=shop`}
                className="md-card md-card-hover shop-card"
                data-testid={`product-card-${p.id}`}
              >
                {p.image_url && (
                  <div className="shop-card-image-wrap">
                    <img src={p.image_url} alt={p.name} className="shop-card-image" />
                  </div>
                )}
                <div className="md-label-eyebrow text-[10px]">{p.category}</div>
                <h3 className="font-serif text-lg mt-2 truncate" title={p.name}>{p.name}</h3>
                <p className="text-xs mt-2" style={{ color: "var(--md-text-soft)" }}>{(p.description || "").slice(0, 70)}…</p>
                <div className="flex items-center justify-between mt-4">
                  <span className="font-serif text-xl">{p.price > 0 ? format(p.price) : "Free"}</span>
                  <button onClick={(e) => quickAdd(e, p)} className="btn-primary text-xs" data-testid={`add-cart-${p.id}`}>
                    <ShoppingCart size={12} weight="bold" /> Add
                  </button>
                </div>
                <div className="shop-card-cta">
                  View details <ArrowRight size={12} weight="bold" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </Page>
  );
}
